import React from 'react'
import PropTypes from 'prop-types'

import SearchEvents from './search/SearchEvents'
import DayView from './day/DayView.js'
import WeekView from './week/WeekView.js'
import MapContainer from './map/MapContainer.js'

export default class ScheduleContentPanel extends React.Component {

  static propTypes = {
    dateStr: PropTypes.string.isRequired,
    searchMode: PropTypes.bool.isRequired,
    viewMode: PropTypes.string,
    selectedWorkers: PropTypes.array.isRequired,
    onDayHeaderClicked: PropTypes.func.isRequired
  }

  render() {
    if (this.props.searchMode) {
      return <SearchEvents />
    }
    switch (this.props.viewMode) {
      case 'day':
        return <DayView
          dateStr={this.props.dateStr}
          selectedWorkers={this.props.selectedWorkers} />
      case 'week':
        return <WeekView
          dateStr={this.props.dateStr}
          selectedWorkers={this.props.selectedWorkers}
          onDayHeaderClicked={this.props.onDayHeaderClicked} />
      case 'map':
        return <MapContainer
          dateStr={this.props.dateStr}
          selectedWorkers={this.props.selectedWorkers} />
    }
    return null
  }

}



// WEBPACK FOOTER //
// ./src/schedule/ScheduleContentPanel.js